import {GetterTree} from 'vuex';
import {RootState} from '@/store/index';
import {MessageState} from '@/store/modules/message/index';
import {MessageModel} from '@/models/Message.model';

export const getters: GetterTree<MessageState, RootState> = {

    messages(state): MessageModel[] {
        return state.messages;
    },
};
